import { createColumnHelper } from '@tanstack/react-table';

import { EdgeConfiguration } from '../../types';

export const columnHelper = createColumnHelper<EdgeConfiguration>();
